import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import Button from '../components/Button';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { deleteSpaceMemberCache } from '../utilities/cache';
import { DELETE_SPACE_USER } from '../utilities/mutations';

const DeleteSpaceMemberModal = ({ member, onClose }) => {
  const params = useParams();
  const toast = useToast();
  const [deleteSpaceMember] = useMutation(DELETE_SPACE_USER);

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()} isDanger>
      <ModalName>Remove {member.user.name}</ModalName>
      <ModalPart>Are you sure you want to remove this user?</ModalPart>
      <ModalPart>
        <Button onClick={() => close()} isExtended>
          Cancel
        </Button>
        <Button
          onClick={async () => {
            try {
              await deleteSpaceMember({
                variables: { spaceSlug: params.s, userId: member.user.id },
                update: (cache, { data: { deleteSpaceMember } }) =>
                  deleteSpaceMemberCache(params.s, cache, deleteSpaceMember),
              });
              toast({ children: `${member.user.name} was removed` });
              onClose();
            } catch (error) {
              toast({ children: error.message });
            }
          }}
          isDanger
          isExtended
        >
          Remove
        </Button>
      </ModalPart>
    </Modal>
  );
};

export default DeleteSpaceMemberModal;
